import React from "react";
import ScheduleEmailForm from "./ScheduleEmailForm";
import EmailCampaignsCards from "./campainingTable/EmailCampaignsCards";

export default function SendSpam() {
  return (<>
    <ScheduleEmailForm/>
    <EmailCampaignsCards/>
  </>)
}

